import React, { useState } from 'react';
import { InformacionAdicionalVacancy } from '../modules/auth/components/InformacionAdicionalVacancy';

export const multiStepContext = React.createContext();

const InformacionAdicionalVacancyContext = () => {
	const [userData, setUserData] = useState([]);
	const [data, setData] = useState([]);
	const [loadedData, setLoadedData] =
		useState(false); /*Used to know if the information has been loaded once (edit mode)*/
	const [loading, setLoading] =useState(false);
	const [shouldDisable, setShouldDisable] = useState(false);

	const submitData = () => {
		setUserData('');
	};

	return (
		<div>
			<multiStepContext.Provider
				value={{
					userData,
					setUserData,
					submitData,
					data,
					setData,
					loadedData,
					setLoadedData,
					loading,
					setLoading,
					shouldDisable,
					setShouldDisable
				}}
			>
				<InformacionAdicionalVacancy/>
			</multiStepContext.Provider>
		</div>
	);
};

export default InformacionAdicionalVacancyContext;
